import { render, staticRenderFns } from "./AddEducationDetails.vue?vue&type=template&id=4e0c718f"
import script from "./AddEducationDetails.vue?vue&type=script&lang=js"
export * from "./AddEducationDetails.vue?vue&type=script&lang=js"
import style0 from "./AddEducationDetails.vue?vue&type=style&index=0&id=4e0c718f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports